import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { RoleService } from '../services/role.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private roleService: RoleService
  ) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = this.authService.getToken();
    if (token == null){
      this.router.navigate(['/login']);
      return false;
    }
    if(!this.authService.getCurrentUser() === null || this.authService.getCurrentUser().roleId == null) {
      this.router.navigate(['/login']);
      return false;
    }
    if (this.roleService.currentUserRole.permissions.length == 0) {
      this.roleService.getCurrentUserRoles(this.authService.getCurrentUser().roleId).toPromise();
    }
    if (!token || token === undefined || token === null) {
      this.router.navigate(['/login']);
      return false;
    }
    if (next.data.admin){
      var user = this.authService.getCurrentUser();
      if (user.userType !== 1 && user.userType !== 3) {
        this.router.navigate(['/']);
        return false;
      }
    }
    if (next.data.permittedRoles && next.data.permittedRoles.length != 0) {
      let permitted = false;

      next.data.permittedRoles.forEach(role => {
        this.roleService.currentUserRole.permissions.forEach(permission => {
          for (const [key, value] of Object.entries(permission)){
            if (value == role){
              permitted= true;
            }
          }
        });
        
      });
      if (!permitted) {
        this.router.navigate(['/login']);
      }
      return permitted;
    }
    return true;
  }

}
